/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Jade_Mouse_FlipInputs */

const en_shy_jade_mouse_flip = /** @type {(inputs: Shy_Jade_Mouse_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign organizational attributes to categorize and segment this member. Attributes are used for reporting, analysis, and targeting specific member groups in surveys.`)
};

const de_shy_jade_mouse_flip = /** @type {(inputs: Shy_Jade_Mouse_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weisen Sie Organisationsmerkmale zu, um dieses Mitglied zu kategorisieren und zu segmentieren. Merkmale werden für Berichte, Analysen und die gezielte Ansprache bestimmter Benutzerergruppen in Befragungen verwendet.`)
};

/**
* | output |
* | --- |
* | "Assign organizational attributes to categorize and segment this member. Attributes are used for reporting, analysis, and targeting specific member groups in ..." |
*
* @param {Shy_Jade_Mouse_FlipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_jade_mouse_flip = /** @type {((inputs?: Shy_Jade_Mouse_FlipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Jade_Mouse_FlipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_jade_mouse_flip(inputs)
	return de_shy_jade_mouse_flip(inputs)
});